import { useQuery } from '@tanstack/react-query'
import { isApiConfigured } from '@/config/api/env'
import { fetchConnections } from '@/services/integrations'
import { workspaceScopedKey } from '@/services/workspaces/workspaceQueryKeys.js'
import { getActiveWorkspaceId } from '@/store/workspaceStore'

export function connectionsQueryKey() {
  return workspaceScopedKey(['integrations', 'connections'])
}

export function useConnections() {
  const workspaceId = getActiveWorkspaceId()
  return useQuery({
    queryKey: connectionsQueryKey(),
    queryFn: ({ signal }) => fetchConnections({ signal }),
    enabled: isApiConfigured() && Boolean(workspaceId),
    staleTime: 15_000,
  })
}
